







































import { Action, Getter } from 'vuex-class'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getEnvironments } from '@/environments'

const { settings: { EXTRA } } = getEnvironments()

const ACCOUNT_MODULE = 'account'

@Component({
  components: {}
})
export default class PerfilControl extends Vue {
  @Action('logout', { namespace: ACCOUNT_MODULE })
  private logout!: any
  @Getter('token', { namespace: ACCOUNT_MODULE })
  private token!: any

  private extraConfs = EXTRA

  path: string = '/opciones'
  get isSubmenuSelected () {
    return this.$route.path === this.path
  }

  async handleLogout () {
    await this.logout()
    this.$router.push('/ingresar')
  }
}
